export const REMOVE_METHOD_MODAL_TITLE =
  "Are you sure you want to remove this MFA method?";

export const MATCHING_PHONE_NUMBER_WARNING_JSX = (
  <>
    You&apos;ll be removing both <strong>Phone-Voice call</strong> and{" "}
    <strong>Phone-SMS</strong> since you&apos;re using the same number for both.
  </>
);
